import { createSprinkles } from '@vanilla-extract/sprinkles/createRuntimeSprinkles';
var sprinkles = createSprinkles({
  conditions: undefined,
  styles: {
    textAlign: {
      values: {
        center: {
          defaultClass: 'sprinkles_textAlign_center__1ugm0ez0'
        },
        inherit: {
          defaultClass: 'sprinkles_textAlign_inherit__1ugm0ez1'
        },
        justify: {
          defaultClass: 'sprinkles_textAlign_justify__1ugm0ez2'
        },
        left: {
          defaultClass: 'sprinkles_textAlign_left__1ugm0ez3'
        },
        right: {
          defaultClass: 'sprinkles_textAlign_right__1ugm0ez4'
        },
        start: {
          defaultClass: 'sprinkles_textAlign_start__1ugm0ez5'
        },
        end: {
          defaultClass: 'sprinkles_textAlign_end__1ugm0ez6'
        }
      }
    }
  }
});
export { sprinkles };
